import React from 'react';
import PhoneInput from 'react-phone-number-input';
import ValidationMessage from '../../validation/ValidationMessage';

const Input = ({ errorMessage, valid, t, type, value, ...rest }) => (
  <React.Fragment>
    { type === 'phone' && (
      <PhoneInput
        placeholder={rest.placeholder || ''}
        value={value}
        name={rest.name}
        className="form-control form-control-modal"
        onChange={phoneValue => rest.onChange({ target: { value: phoneValue, name: rest.name } })}
      />
    )}
    { type !== 'phone' && (
      <input type={type} value={value} {...rest} className="form-control form-controllogin" />
    )}
    <ValidationMessage message={errorMessage} valid={valid} />
  </React.Fragment>
);

Input.propTypes = {
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/login/input/Input.jsx